import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type DigitalCredentialCardConfig } from './digital-credential-card.types';

@Component({
  selector: 'app-digital-credential-card',
  templateUrl: './digital-credential-card.html',
  imports: [Dynamic, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DigitalCredentialCard {
  readonly config = input.required<DigitalCredentialCardConfig>();
  readonly disabled = input<boolean>(false);

  readonly action = output<DynamicAction>();

  protected onClick(): void {
    const action = this.config().action;
    if (action && !this.disabled()) {
      this.action.emit(action);
    }
  }
}
